import { AnyAction } from 'redux';
import { ApplicationState } from 'app/types-store';
import { ActionDispatching } from 'app/types-shared';
import { STATE } from 'app/constants';
import { ErrorNotification, SuccessNotification } from 'app/infrastructure/notifications/user-messages';
import { isForbiddenStatus, blockAccess } from 'app/area/shared/actions-utils';
import { importSetAdminTranslation } from '../constants';
import { defaultMaxResults } from './constants';
import {
  ClearList,
  RequestList, ReceiveList, FailList,
  RequestDeleteImportSet, ReceiveDeleteImportSet, FailDeleteImportSet,
  ClearAddImportSet, UpdateAddImportSetIsDirty, UpdateAddImportSetState,
  AddImportSetFieldsByKey, ResetAddImportSetValidation
} from './action-types';
import { api } from './api';
import { mapList } from './map-list';
import { ImportSetsSearchModel } from './types-store';
import { ChangeOptionType } from 'app/area/import-sets-administration/list/types';
import { replaceTemplateString } from 'app/infrastructure/platform';

export const actionCreators = {

  clearList: (): ActionDispatching<AnyAction, ApplicationState> =>
    (dispatch, getState) => {
      const requestId = Date.now();
      dispatch(new ClearList(requestId));
    },

  loadList: (
    model: ImportSetsSearchModel,
    startIndex: number = 0,
    maxResults: number = defaultMaxResults
  ): ActionDispatching<AnyAction, ApplicationState> =>
    async (dispatch, getState) => {

      const requestId = Date.now();
      dispatch(new RequestList(requestId, model, startIndex === 0));

      try {
        const listResponse = await api.loadList(model, startIndex, maxResults);

        dispatch(new ReceiveList(requestId, mapList(listResponse.results), listResponse.totalNumberOfResults));
      } catch (err) {
        err && err.userMessages && dispatch(new ErrorNotification(err.userMessages));

        if (isForbiddenStatus(err)) {
          blockAccess({
            dispatch,
            getState,
            area: STATE.importSetAdministration,
            translationId: importSetAdminTranslation.no_access_to_import_set_admin
          });
        }

        dispatch(new FailList(requestId));
      }
    },

  deleteImportSet: (id: number, importSetText: string, successMessage: string): ActionDispatching<any, any> =>
    async (dispatch: any, getState: any) => {

      dispatch(new RequestDeleteImportSet(id));

      try {

        await api.deleteImportSet(id);
        dispatch(new ReceiveDeleteImportSet(id));
        dispatch(new SuccessNotification(replaceTemplateString(successMessage, importSetText)));

      } catch (err) {

        if (err && (err.userMessages || err.message)) {
          dispatch(new ErrorNotification(err.userMessages || err.message));
        }
        dispatch(new FailDeleteImportSet(id));
      }
    },

  clearAddImportSet: (): ActionDispatching<any, any> =>
    async (dispatch, getState) => {

      dispatch(new ClearAddImportSet());
    },

  updateAddImportSetIsDirty: (value: boolean): ActionDispatching<any, any> => (dispatch: any, getState: any) => {
    dispatch(new UpdateAddImportSetIsDirty(value));
  },

  updateAddImportSetState: (value: ChangeOptionType): ActionDispatching<any, any> => (dispatch: any, getState: any) => {
    dispatch(new UpdateAddImportSetState(value));
  },

  updateAddImportSetFieldsByKey: <T>(key: string, value: T): ActionDispatching<any, any> =>
    (dispatch: any, getState: any) => {
      dispatch(new AddImportSetFieldsByKey(key, value));
    },

  resetAddImportSetValidation: (key: string): ActionDispatching<any, any> => (dispatch: any, getState: any) => {
    dispatch(new ResetAddImportSetValidation(key));
  },

  displayError: (errorMessage: string): ActionDispatching<any, any> =>
    (dispatch, getState) => {
      dispatch(new ErrorNotification(errorMessage));
    }
};
